import RequestBetaEnterCode from "./RequestBetaEnterCode";

export default RequestBetaEnterCode;
